import { render } from "./BaseDataField.vue?vue&type=template&id=2c3e6b41"
import script from "./BaseDataField.vue?vue&type=script&lang=js"
export * from "./BaseDataField.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__